export const anrede = ['Herr', 'Frau'];
